/*
 *
 * UploadCameraMedia actions
 *
 */

import {
  CHANGE_DATA,
  FLUSH_STATE,
  UPLOAD_MEDIA_FILE,
  UPLOAD_MEDIA_FILE_SUCCESS,
  UPLOAD_MEDIA_FILE_ERROR,
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}
export function changeData() {
  return {
    type: CHANGE_DATA,
  };
}

/**
 * Load the variables, this action starts the request saga
 *
 * @return {object} An action object with a type of UPLOAD_MEDIA_FILE
 */
export function uploadCameraMediaFile(file, fileType) {
  return {
    type: UPLOAD_MEDIA_FILE,
    file,
    fileType,
  };
}

/**
 * Dispatched when the uploadCameraMediaFile are loaded by the request saga
 *
 * @param  {array} variables true for variables
 *
 * @return {object}      An action object with a type of UPLOAD_MEDIA_FILE_SUCCESS passing the variables
 */
export function uploadCameraMediaFileSuccess(uploadedFile, uploadedFileType) {
  return {
    type: UPLOAD_MEDIA_FILE_SUCCESS,
    uploadedFile,
    uploadedFileType,
  };
}

/**
 * Dispatched when loading the uploadCameraMediaFile fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of UPLOAD_MEDIA_FILE_ERROR passing the error
 */
export function uploadCameraMediaFileError(error) {
  return {
    type: UPLOAD_MEDIA_FILE_ERROR,
    error,
  };
}
